import { assetApi as api } from './assetApi';
export const addTagTypes = ['Assets', 'FaceDetections', 'People'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getAssets: build.query<GetAssetsApiResponse, GetAssetsApiArg>({
        query: queryArg => ({
          url: `/assets`,
          params: {
            search: queryArg.search,
            things: queryArg.things,
            sharedWith: queryArg.sharedWith,
            interactions: queryArg.interactions,
            favorites: queryArg.favorites,
            location: queryArg.location,
            folderId: queryArg.folderId,
            people: queryArg.people,
            mediaType: queryArg.mediaType,
            date: queryArg.date,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            type: queryArg['type']
          }
        })
        // providesTags: ['Assets']
      }),
      assetSearch: build.mutation<AssetSearchApiResponse, AssetSearchApiArg>({
        query: queryArg => ({
          url: `/assetSearch`,
          method: 'POST',
          body: queryArg.assetSearch
        })
        // invalidatesTags: ['Assets']
      }),
      assetCount: build.query<AssetCountApiResponse, AssetCountApiArg>({
        query: () => ({ url: `/assetCount` }),
        providesTags: ['Assets']
      }),
      getUserAssets: build.query<GetUserAssetsApiResponse, GetUserAssetsApiArg>(
        {
          query: queryArg => ({
            url: `/user/assets`,
            params: {
              mediaType: queryArg.mediaType,
              offset: queryArg.offset,
              limit: queryArg.limit
            }
          }),
          providesTags: ['Assets']
        }
      ),
      assetContributionsCount: build.query<
        AssetContributionsCountApiResponse,
        AssetContributionsCountApiArg
      >({
        query: () => ({ url: `/assetContributionsCount` }),
        providesTags: ['Assets']
      }),
      mergeAsset: build.mutation<MergeAssetApiResponse, MergeAssetApiArg>({
        query: queryArg => ({
          url: `/mergeAsset`,
          method: 'POST',
          body: queryArg.mergeAssetBody,
          params: { type: queryArg['type'], module: queryArg['module'] }
        }),
        invalidatesTags: ['Assets']
      }),
      getAssetsById: build.query<GetAssetsByIdApiResponse, GetAssetsByIdApiArg>(
        {
          query: queryArg => ({ url: `/assets/${queryArg.id}` }),
          providesTags: ['Assets']
        }
      ),
      updateAssets: build.mutation<UpdateAssetsApiResponse, UpdateAssetsApiArg>(
        {
          query: queryArg => ({
            url: `/assets/${queryArg.id}`,
            method: 'PUT',
            body: queryArg.assetsCreateObject
          }),
          invalidatesTags: ['Assets']
        }
      ),
      deleteAssets: build.mutation<DeleteAssetsApiResponse, DeleteAssetsApiArg>(
        {
          query: queryArg => ({
            url: `/assets/${queryArg.id}`,
            method: 'DELETE',
            params: { delete: queryArg['delete'] }
          }),
          invalidatesTags: ['Assets']
        }
      ),
      bulkDeleteAssets: build.mutation<
        BulkDeleteAssetsApiResponse,
        BulkDeleteAssetsApiArg
      >({
        query: queryArg => ({
          url: `/assets/bulk-delete`,
          method: 'POST',
          body: queryArg.body,
          params: { delete: queryArg['delete'] }
        }),
        invalidatesTags: ['Assets']
      }),
      getAssetLocations: build.query<
        GetAssetLocationsApiResponse,
        GetAssetLocationsApiArg
      >({
        query: queryArg => ({
          url: `/locations`,
          params: {
            location: queryArg.location,
            module: queryArg['module'],
            momentId: queryArg.momentId,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            type: queryArg['type'],
            userFolderId: queryArg.userFolderId,
            peopleId: queryArg.peopleId,
            isInsidePeople: queryArg.isInsidePeople,
            isSharedWithMe: queryArg.isSharedWithMe,
            isMyFiles: queryArg.isMyFiles,
            access: queryArg.access,
            groupId: queryArg.groupId
          }
        }),
        providesTags: ['Assets']
      }),
      getAssetThings: build.query<
        GetAssetThingsApiResponse,
        GetAssetThingsApiArg
      >({
        query: queryArg => ({
          url: `/things`,
          params: {
            location: queryArg.location,
            module: queryArg['module'],
            momentId: queryArg.momentId,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            type: queryArg['type'],
            userFolderId: queryArg.userFolderId,
            peopleId: queryArg.peopleId,
            isInsidePeople: queryArg.isInsidePeople,
            isSharedWithMe: queryArg.isSharedWithMe,
            isMyFiles: queryArg.isMyFiles,
            access: queryArg.access,
            groupId: queryArg.groupId
          }
        }),
        providesTags: ['Assets']
      }),
      getAssetsPeople: build.query<
        GetAssetsPeopleApiResponse,
        GetAssetsPeopleApiArg
      >({
        query: queryArg => ({
          url: `/assetsPeople`,
          params: { id: queryArg.id }
        }),
        providesTags: ['Assets']
      }),
      getAssetTypeList: build.query<
        GetAssetTypeListApiResponse,
        GetAssetTypeListApiArg
      >({
        query: queryArg => ({
          url: `/assetTypeList`,
          params: {
            module: queryArg['module'],
            momentId: queryArg.momentId,
            peopleId: queryArg.peopleId,
            userFolderId: queryArg.userFolderId,
            isInsidePeople: queryArg.isInsidePeople,
            isSharedWithMe: queryArg.isSharedWithMe,
            isMyFiles: queryArg.isMyFiles,
            access: queryArg.access,
            groupId: queryArg.groupId
          }
        }),
        providesTags: ['Assets']
      }),
      getAssetActivitiesCount: build.query<
        GetAssetActivitiesCountApiResponse,
        GetAssetActivitiesCountApiArg
      >({
        query: queryArg => ({
          url: `/assetActivitiesCount`,
          params: {
            module: queryArg['module'],
            momentId: queryArg.momentId,
            userFolderId: queryArg.userFolderId,
            peopleId: queryArg.peopleId,
            isInsidePeople: queryArg.isInsidePeople,
            isSharedWithMe: queryArg.isSharedWithMe,
            isMyFiles: queryArg.isMyFiles,
            access: queryArg.access,
            groupId: queryArg.groupId
          }
        }),
        providesTags: ['Assets']
      }),
      assetsShareWithMe: build.mutation<
        AssetsShareWithMeApiResponse,
        AssetsShareWithMeApiArg
      >({
        query: queryArg => ({
          url: `/assetsShareWithMe`,
          method: 'POST',
          body: queryArg.assetsSharedWithMe
        }),
        invalidatesTags: ['Assets']
      }),
      reassignFace: build.mutation<ReassignFaceApiResponse, ReassignFaceApiArg>(
        {
          query: queryArg => ({
            url: `/faceDetections/reassign`,
            method: 'POST',
            body: queryArg.body
          }),
          invalidatesTags: ['FaceDetections']
        }
      ),
      duplicateInContributor: build.mutation<
        DuplicateInContributorApiResponse,
        DuplicateInContributorApiArg
      >({
        query: queryArg => ({
          url: `/people/duplicateInContributor`,
          method: 'POST',
          body: queryArg.peopleIds
        }),
        invalidatesTags: ['People']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetAssetsApiResponse = /** status 200 Assets found. */ {
  ok?: boolean;
  data?: Assets;
  message?: string;
};
export type GetAssetsApiArg = {
  /** Search text */
  search?: string;
  /** Search text */
  things?: string;
  /** Search text */
  sharedWith?: string;
  /** Search text */
  interactions?: string;
  /** Search text */
  favorites?: string;
  /** Search text */
  location?: string;
  /** Search text */
  folderId?: string;
  /** Search text */
  people?: string;
  /** Search text */
  mediaType?: string;
  /** Search text */
  date?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** type */
  type?: string;
};
export type AssetSearchApiResponse =
  /** status 201 Assets has been created successfully. */ {
    ok?: boolean;
    data?: Assets;
    message?: string;
  };
export type AssetSearchApiArg = {
  /** Assets that needs to be added to the application */
  assetSearch: AssetSearch;
};
export type AssetCountApiResponse =
  /** status 200 Total count of assets retrieved successfully. */ {
    ok?: boolean;
    data?: AssetCount;
    message?: string;
  };
export type AssetCountApiArg = void;
export type GetUserAssetsApiResponse =
  /** status 200 User assets retrieved successfully. */ {
    ok?: boolean;
    data?: UserAssets;
    message?: string;
  };
export type GetUserAssetsApiArg = {
  /** Filter by media type (e.g., image, video). Can be single value or array. */
  mediaType?: string[];
  /** Number of records to skip for pagination */
  offset?: number;
  /** Maximum number of records to return */
  limit?: number;
};
export type AssetContributionsCountApiResponse =
  /** status 200 Total count of assets retrieved successfully. */ {
    ok?: boolean;
    data?: AssetCount;
    message?: string;
  };
export type AssetContributionsCountApiArg = void;
export type MergeAssetApiResponse =
  /** status 200 Assets merged successfully. */ {
    ok?: boolean;
    data?: MergeAssetResponse;
    message?: string;
  };
export type MergeAssetApiArg = {
  /** Type of merge operation */
  type: string;
  /** Module from which the merge operation was initiated */
  module?: string;
  /** Assets that needs to be added to the application */
  mergeAssetBody: MergeAssetBody;
};
export type GetAssetsByIdApiResponse = /** status 200 Assets details found. */ {
  ok?: boolean;
  data?: Asset;
  message?: string;
};
export type GetAssetsByIdApiArg = {
  /** ID of the Assets to retrieve */
  id: string;
};
export type UpdateAssetsApiResponse =
  /** status 200 The Assets's details has been updated successfully */ {
    ok?: boolean;
    data?: Assets;
    message?: string;
  };
export type UpdateAssetsApiArg = {
  /** ID of the Assets to update */
  id: string;
  /** Assets that needs to be added to the application */
  assetsCreateObject: AssetsCreateObject;
};
export type DeleteAssetsApiResponse =
  /** status 200 The Assets's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteAssetsApiArg = {
  /** ID of the Assets to delete */
  id: string;
  /** flag to hard delete */
  delete?: string;
};
export type BulkDeleteAssetsApiResponse =
  /** status 200 Assets have been deleted successfully */ {
    ok?: boolean;
    data?: {
      success?: boolean;
      deletedCount?: number;
    };
    message?: string;
  };
export type BulkDeleteAssetsApiArg = {
  /** flag to hard delete (true for permanent deletion) */
  delete?: boolean;
  /** Array of asset IDs to delete */
  body: {
    assetIds?: string[];
  };
};
export type GetAssetLocationsApiResponse = /** status 200 Assets found. */ {
  ok?: boolean;
  data?: Locations;
  message?: string;
};
export type GetAssetLocationsApiArg = {
  /** Search text */
  location?: string;
  /** Module ID for filtering */
  module?: string;
  /** Moment ID for filtering */
  momentId?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** type */
  type?: string;

  userFolderId?: string;

  peopleId?: string;
  isInsidePeople?: boolean;
  isSharedWithMe?: boolean;
  isMyFiles?: boolean;
  access?: string;
  groupId?: string;
};
export type GetAssetThingsApiResponse = /** status 200 Assets found. */ {
  ok?: boolean;
  data?: Things;
  message?: string;
};
export type GetAssetThingsApiArg = {
  /** Search text */
  location?: string;
  /** Search text */
  module: string;
  /** Moment ID for filtering */
  momentId?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** type */
  type?: string;

  userFolderId?: string;

  peopleId?: string;
  isInsidePeople?: boolean;
  isSharedWithMe?: boolean;
  isMyFiles?: boolean;
  access?: string;
  groupId?: string;
};
export type GetAssetsPeopleApiResponse =
  /** status 200 Assets details found. */ {
    ok?: boolean;
    data?: AssetPeople;
    message?: string;
  };
export type GetAssetsPeopleApiArg = {
  /** ID of the Assets to retrieve */
  id: string;
};
export type GetAssetTypeListApiResponse =
  /** status 200 Assets details found. */ {
    ok?: boolean;
    data?: AssetTypeCount;
    message?: string;
  };
export type GetAssetTypeListApiArg = {
  /** Module of the Assets to retrieve */
  module?: string;
  /** Moment ID for filtering */
  momentId?: string;
  peopleId?: string;
  userFolderId?: string;
  isInsidePeople?: boolean;
  isSharedWithMe?: boolean;
  isMyFiles?: boolean;
  access?: string;
  groupId?: string;
};
export type GetAssetActivitiesCountApiResponse =
  /** status 200 Assets details found. */ {
    ok?: boolean;
    data?: AssetActivitiesCount;
    message?: string;
  };
export type GetAssetActivitiesCountApiArg = {
  /** Module of the Assets to retrieve */
  module?: string;
  /** Moment ID for filtering */
  momentId?: string;

  userFolderId?: string;

  peopleId?: string;
  isInsidePeople?: boolean;
  isSharedWithMe?: boolean;
  isMyFiles?: boolean;
  access?: string;
  groupId?: string;
};
export type AssetsShareWithMeApiResponse =
  /** status 200 Assets details found. */ {
    ok?: boolean;
    data?: AssetsSharedWithMeResponse;
    message?: string;
  };
export type AssetsShareWithMeApiArg = {
  /** Assets that needs to be added to the application */
  assetsSharedWithMe: AssetsSharedWithMe;
};
export type ReassignFaceApiResponse =
  /** status 200 Face reassigned successfully. */ void;
export type ReassignFaceApiArg = {
  /** The selected face and its new owner */
  body: {
    faceDetectionId?: string;
    newPeopleId?: string;
    newPeopleImageUrl?: string;
    reindexInRekognition?: boolean;
  };
};

export type DuplicateInContributorApiResponse =
  /** status 200 Shared people merged successfully */ {
    data: {
      exists: boolean;
      person: {
        id: string;
        name: string;
        email: string;
        userId: string;
      };
      existingPeople: {
        peopleId: string;
        name: string;
      }[];
    };
  };
export type DuplicateInContributorApiArg = {
  /** Person data to create in both databases */
  peopleIds: PeopleIds[];
};

export type Assets = {
  count: number;
  rows: {
    id?: string;
    status?: string;
    subscriberId?: string;
    userId?: string;
    location?: string;
    metadata?: {
      size?: string;
      filters?: string;
    };
    url?: string;
    thumbNailUrl?: string;
    createdAt?: string;
    updatedAt?: string;
    fileName?: any;
    contentType?: any;
    size?: any;
    createdBy?: any;
    assetViewDetail: {
      updatedAt?: string;
    };
    sharedWith?: {
      count?: number;
      people?: {
        peopleId?: string;
        name?: string;
        email?: string;
        profileImage?: string;
        status?: string;
      }[];
    };
  }[];
};
export type AssetSearch = {
  sortBy?: string;
  orderBy?: string;
  offset?: number;
  limit?: number;
  search?: string;
  userId?: string;
  subscriberId?: string;
  favorites?: boolean;
  sharedWith?: string;
  people?: any[];
  things?: any[];
  locations?: any[];
  dates?: any[];
  interactions?: any[];
  mediaType?: any[];
  userFolderId?: string;
  isTrash?: boolean;
  peopleId?: string;
  ownerId?: string;
  isInsidePeople?: boolean;
  isSharedWithMe?: boolean;
  isMyFiles?: boolean;
};
export type AssetCount = {
  count?: number;
};
export type UserAssets = {
  count: number;
  totalCount: number;
  rows: {
    id?: string;
    status?: string;
    subscriberId?: string;
    userId?: string;
    fileName?: string;
    location?: string;
    url?: string;
    thumbNailUrl?: string;
    contentType?: string;
    type?: string;
    size?: number;
    userFolderId?: any;
    module?: string;
    createdAt?: string;
    updatedAt?: string;
  }[];
};
export type AssetPeople = {
  id: string;
  name: string | null;
  profileImage: string;
  subscriberId: string;
  userId: string;
}[];
export type MergeAssetResponse = {
  success?: boolean;
};
export type MergeAssetBody = {
  assetIds?: string[];
  isReject?: boolean;
  groupId?: string;
  type?: 'asset' | 'recipe' | 'memory' | 'group';
};
export type Asset = {
  id?: string;
  fileName?: any;
  thumbNailUrl?: string;
  userId?: string;
  subscriberId?: string;
  contentType?: any;
  url?: string;
  size?: number;
  type?: string;
  status?: string;
  userFolderId?: any;
  createdAt?: string;
  updatedAt?: string;
  location?: string;
  metadata?: any;
  takenDate?: string;
  isPrivate?: boolean;
  createdBy?: string;
  mediaOwner?: boolean;
  locationDetails: {
    address?: string;
    addressNumber?: string;
    city?: string;
    country?: string;
    geohash?: string;
    municipality?: string;
    postalCode?: string;
    region?: string;
    street?: string;
    subRegion?: string;
  };
  user?: {
    userId?: string;
    fullName?: string;
    email?: string;
    userDetail?: {
      profileImage?: string;
      firstName?: string;
      lastName?: string;
    };
  };
  favorite: {
    id: string;
    status: string;
  };
  assetViewDetails?: {
    id?: string;
    userId?: string;
    assetId?: string;
    status?: string;
    createdAt?: string;
    updatedAt?: string;
  };
  faceDetections?: {
    id?: string;
    assetId?: string;
    faceId?: string;
    userId?: string;
    confidence?: number;
    boundingBox?: {
      top?: number;
      left?: number;
      width?: number;
      height?: number;
    };
    faceAttributes?: {
      beard?: {
        value?: boolean;
        confidence?: number;
      };
      smile?: {
        value?: boolean;
        confidence?: number;
      };
      gender?: {
        value?: string;
        confidence?: number;
      };
      ageRange?: {
        low?: number;
        high?: number;
      };
      emotions?: {
        type?: string;
        confidence?: number;
      }[];
      eyeglasses?: {
        value?: boolean;
        confidence?: number;
      };
    };
    isVerified?: boolean;
    taggedBy?: string;
    createdAt?: string;
    updatedAt?: string;
    user?: {
      userId?: string;
      fullName?: string;
      email?: string;
      userDetail?: {
        profileImage?: string;
      };
    };
  }[];
  photoTags?: {
    id?: string;
    assetId?: string;
    tagName?: string;
    confidence?: number;
    tagType?: string;
    boundingBox?: any;
    createdAt?: string;
    updatedAt?: string;
  }[];
  people: {
    id: string;
    name: string | null;
    profileImage: string;
    userId: string;
  }[];
};
export type AssetsCreateObject = {
  subscriberId?: string;
  mediaType?: string;
  userId?: string;
  fileSizeBytes?: number;
  takenDate?: string;
  imageSize?: {
    width?: number;
    height?: number;
  };
  location?: string;
  metadata?: {
    filters?: string;
    location?: string;
    size?: string;
  };
};
export type Locations = {
  subscriberId?: string;
  location?: string;
  location_count?: string;
}[];
export type Things = {
  subscriberId?: string;
  tagName?: string;
  asset_count?: string;
  tag_count?: string;
}[];
export type AssetTypeCount = {
  key?: string;
  label?: string;
  count?: string;
}[];
export type AssetActivitiesCount = {
  key?: string;
  label?: string;
  count?: string;
}[];
export type People = {
  count?: number;
  rows?: {
    userId?: string;
    fullName?: string;
    email?: string;
    profileImage?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: any;
    dateOfBirth?: any;
    gender?: any;
    maxConfidence?: number;
    isVerified?: boolean;
    detectionCount?: number;
  }[];
};

export type AssetsSharedWithMeResponse = {
  count?: number;
  rows?: {
    ownerPeopleId?: string;
    recipientPeopleId?: string;
    recipientName?: string;
    recipientProfileImage?: string;
    recipientType?: string;
    subscriberId?: string;
    assetCount?: string;
  }[];
};
export type AssetsSharedWithMe = {
  module?: string;
  mediaType?: any[];
  locations?: any[];
  startDate?: any[];
  endDate?: any[];
  things?: any[];
  people?: any[];
  offset?: string;
  limit?: string;
  peopleId?: string;
  isInsidePeople?: boolean;
  isSharedWithMe?: boolean;
  isMyFiles?: boolean;
  access?: string;
  groupId?: string;
  userFolderId?: string;
};
export type PeopleIds = {
  peopleIds: string[];
};
export const {
  useGetAssetsQuery,
  useAssetSearchMutation,
  useAssetCountQuery,
  useGetUserAssetsQuery,
  useAssetContributionsCountQuery,
  useMergeAssetMutation,
  useGetAssetsPeopleQuery,
  useGetAssetsByIdQuery,
  useLazyGetAssetsByIdQuery,
  useUpdateAssetsMutation,
  useDeleteAssetsMutation,
  useBulkDeleteAssetsMutation,
  useGetAssetLocationsQuery,
  useGetAssetThingsQuery,
  useGetAssetTypeListQuery,
  useGetAssetActivitiesCountQuery,
  useAssetsShareWithMeMutation,
  useReassignFaceMutation,
  useDuplicateInContributorMutation
} = injectedRtkApi;
